import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getTournamentDetail } from "../../api/tournaments";
import { TournamentDetail } from "../../components";
import { ITournament } from "../../models/ITournament";
import { Button, EmptyState, Loader } from "../../ui";
import "./styles.scss";

const TournamentDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(true);
  const [tournament, setTournament] = useState<ITournament>();

  const getTournamentData = async () => {
    setLoading(true);
    try {
      const { data } = await getTournamentDetail(id!);
      setTournament(data);
      document.title = `${data?.name}`;
    } catch (err: any) {
      console.error("Failed to load tournament detail", err);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = (count: number) => {
    const goTo = searchParams.get("goTo");
    const playerId = searchParams.get("playerId");

    if (goTo === "player" && playerId) {
      navigate(`/dashboard/players/${playerId}`);
    } else {
      // Preserve all search params except goTo and playerId when navigating back
      const params = new URLSearchParams(searchParams);
      params.delete("goTo");
      params.delete("playerId");
      const queryString = params.toString();
      navigate(`/dashboard/tournaments${queryString ? `?${queryString}` : ""}`);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    getTournamentData();
  }, []);

  return (
    <div className="tournament-detail-page">
      {loading ? (
        <Loader minHeight={300} />
      ) : tournament ? (
        <div>
          <TournamentDetail item={tournament} onBack={handleBack} onDoneEdit={getTournamentData} />
        </div>
      ) : (
        <EmptyState
          className="tournament-load-error"
          title="Could not load this tournament."
          action={
            <Button variant="tint" onClick={getTournamentData}>
              Retry
            </Button>
          }
        />
      )}
    </div>
  );
};

export default TournamentDetailPage;
